type PaginationProps = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1).filter((item) => {
    if (totalPages <= 7) return true;
    if (item === 1 || item === totalPages) return true;
    return Math.abs(item - page) <= 1;
  });

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        aria-label="上一页"
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" />
      </button>

      {pages.map((item, index) => {
        const previous = pages[index - 1];
        const showGap = previous && item - previous > 1;
        return (
          <span key={item} className="flex items-center gap-2">
            {showGap && <span className="px-1 text-xs text-foreground-400">···</span>}
            <button
              type="button"
              onClick={() => onChange(item)}
              aria-current={item === page ? "page" : undefined}
              className={`h-9 min-w-9 cursor-pointer rounded-md border px-2.5 text-sm transition-colors ${
                item === page
                  ? "border-accent-500 bg-accent-500 font-medium text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-700 hover:border-accent-400 hover:text-accent-600"
              }`}
            >
              {item}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        aria-label="下一页"
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-right-s-line" />
      </button>

      <span className="ml-2 font-label text-xs text-foreground-500">
        第 {page} / {totalPages} 页
      </span>
    </div>
  );
}